import { useRef, useCallback } from 'react'
import { updateThirteenthMonthSummaries } from '../../../../api/payroll'
import getCutoffPeriod from '../functions/getCutOffPeriod'
import { useParams } from 'react-router-dom'

const useUpdateThirteenthMonthPayHook = () => {
    let updates = useRef({})
    let { id } = useParams()



    /*

    {
        recordId: {
            `date_ranges.${index}.basic_pay`: value,
            total_basic_pay: value,
            total_13th_month: value,
            '$addToSet': {
                date_ranges: {
                    $each: [
                        { basic_pay, payroll_from, payroll_to },
                        { basic_pay, payroll_from, payroll_to },
                    ]
                }
            }
        }
    }
        */



    const updateThirteenthMonthPay = useCallback((recordId, index, basicPay, totalBasicPay, totalThirteenthMonthPay, from, to) => {
        
        const newTotalBasicPay = Number(totalBasicPay);
        const newTotalThirteenthMonthPay = Number(totalThirteenthMonthPay);

        let cutoff = getCutoffPeriod({ payroll_from: from, payroll_to: to });
        let newEntries = updates.current[recordId]?.$addToSet?.date_ranges?.$each || [];
        
        let entryIndex = newEntries.findIndex((entry) => {
            let entryCutoff = getCutoffPeriod({ payroll_from: entry.payroll_from, payroll_to: entry.payroll_to });
            return entryCutoff === cutoff;
        })
        
        if (entryIndex !== -1) {
            newEntries[entryIndex].basic_pay = basicPay;
            newEntries[entryIndex].payroll_from = from;
            newEntries[entryIndex].payroll_to = to;

            let updatedEntries = removeDuplicateEntries(newEntries);
            
            updates.current[recordId] = {
                ...updates.current[recordId],
                total_basic_pay: newTotalBasicPay,
                total_13th_month: newTotalThirteenthMonthPay,
                "$addToSet": {
                    date_ranges: {
                        $each: updatedEntries
                    }
                }
            }
            return;
        }
        updates.current[recordId] = {
            ...updates.current[recordId],
            [`date_ranges.${index}.basic_pay`]: basicPay,
            [`date_ranges.${index}.payroll_from`]: from,
            [`date_ranges.${index}.payroll_to`]: to,
            total_basic_pay: newTotalBasicPay,
            total_13th_month: newTotalThirteenthMonthPay
        }


    }, [])


    const removeDuplicateEntries = useCallback((entries) => {
        let seen = new Set();
        return entries.filter((entry) => {
            let key = entry?.payroll_from + '-' + entry?.payroll_to;
            if (seen.has(key)) {
                return false;
            } else {
                seen.add(key);
                return true;
            }
        })
    }, [])

    const newThirteenthMonthPay = useCallback((recordId, basic_pay, payroll_from, payroll_to, totalBasicPay, totalThirteenthMonthPay) => {
        let newEntries = removeDuplicateEntries([...updates.current[recordId]?.new_entries || [], { basic_pay, payroll_from, payroll_to }]);
        updates.current[recordId] = {
            ...updates.current[recordId],
            total_basic_pay: Number(totalBasicPay),
            total_13th_month: totalThirteenthMonthPay,
            "$addToSet": {
                date_ranges: {
                    $each: newEntries
                }
            }
        }
    }, [])


    const getUpdatedBasicPay = useCallback((recordId, index) => {
        if (updates.current[recordId] && updates.current[recordId][index]) {
            return updates.current[recordId][index]['basic_pay']
        }
        return null
    }, [])

    const getAllUpdates = useCallback(() => {
        return updates.current
    }, [])

    const submitChanges = useCallback(async () => {
        // This function can be used to submit all updates to the server
        //For example, you can iterate over updates.current and send them in a batch request
        const total13thMonthAllEmployees = Object.values(updates.current).reduce(
          (acc, emp) => acc + (emp.total_13th_month || 0),
          0
        );

        await updateThirteenthMonthSummaries(id, updates.current);
        updates.current = {}
    }, [])

    const removeChanges = useCallback(() => {
        updates.current = {}
    }, [])

    return {
        updateThirteenthMonthPay,
        getUpdatedBasicPay,
        getAllUpdates,
        submitChanges,
        removeChanges,
        newThirteenthMonthPay
    }

}

export default useUpdateThirteenthMonthPayHook